import React from "react"
import styled from "@emotion/styled"
import { Flex } from "theme-ui"
import WhatsNewList from "components/lists/whats-new-list"

const Wrapper = styled.div`
    position: relative;
    margin-bottom: 3rem;
    background: ${(props) => props.theme.colors.background};

    & .position {
        justify-content: center;
    }

    & h2 {
        margin-bottom: 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 0 2rem;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 1rem;
        & h2 {
            font-size: 30px;
        }
        & p {
            font-size: 16px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & h2 {
            font-size: 27px;
        }
        & p {
            font-size: 15px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
        padding: 1rem;
        & h2 {
            font-size: 17px;
        }
        & p {
            font-size: 13px;
        }
    }
`

function Services({ data, description, url }) {
    return (
        <Wrapper>
            <Flex className="position">
                <h2>Whats New</h2>
            </Flex>
            <Flex
                className="position"
                sx={{
                    margin: "auto",
                }}
            >
                <div dangerouslySetInnerHTML={{ __html: description }} />
            </Flex>
            <Flex>
                <WhatsNewList data={data} url={url} />
            </Flex>
        </Wrapper>
    )
}

export default Services
